import { dispatch } from '@wordpress/data';
import {
  PluginSidebar,
  PluginSidebarMoreMenuItem,
  store as editPostStore,
} from '@wordpress/edit-post';

import './styles.scss';

/**
 * A full-width block editor plugin panel with an optional sidebar.
 *
 * Includes a menu item in the 'more menu' that opens the panel.
 *
 * @param {Object}          props               The component props
 * @param {string}          props.slug          The slug of the panel
 * @param {WPComponentIcon} props.icon          The icon for the panel
 * @param {string}          props.title         The title of the panel
 * @param {Function}        props.renderSidebar A function that returns the sidebar content
 * @param {JSX.Element}     props.children      The main panel content
 *
 * @return {JSX.Element}                         The panel component
 */
const Panel = ({ slug, icon, title, renderSidebar, children }) => {
  /**
   * Handles the escape keydown event to close the sidebar.
   *
   * @param {React.KeyboardEvent<HTMLDivElement>} event The keyboard event
   * @return {void}
   */
  const handleEscapeKeyDown = (event) => {
    if ((event.code === 'Escape' || event.key === 'Escape') && !event.defaultPrevented) {
      event.preventDefault();
      dispatch(editPostStore).closeGeneralSidebar(slug);
    }
  };

  return (
    <>
      <PluginSidebarMoreMenuItem target={slug} icon={icon}>
        {title}
      </PluginSidebarMoreMenuItem>
      <PluginSidebar name={slug} icon={icon} title={title}>
        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions -- we need to handle escape key press when any item within the panel is focused */}
        <div className="mediapress-panel" onKeyDown={handleEscapeKeyDown}>
          {renderSidebar && <div className="mediapress-panel__sidebar">{renderSidebar()}</div>}
          {children}
        </div>
      </PluginSidebar>
    </>
  );
};

export default Panel;
